import { render, staticRenderFns } from "./posmaliyetraporu.vue?vue&type=template&id=5c0f81c0&"
import script from "./posmaliyetraporu.vue?vue&type=script&lang=js&"
export * from "./posmaliyetraporu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports